<template>
  <div class="pc-layout__note pc-layout__container">
    <tab-sidebar/>
    <router-view/>
    <add-notebook-catalog-dialog/>
    <add-notebook-note-dialog/>
    <rename-dialog/>
    <insert-image-dialog/>
    <upload-image-dialog/>
  </div>
</template>

<script>
// import Sidebar from '@/components/note/sidebar/Sidebar.vue'
import TabSidebar from '@/components/note/sidebar/TabSidebar.vue'
import AddNotebookCatalogDialog from '@/components/dialog/AddNotebookCatalogDialog.vue'
import AddNotebookNoteDialog from '@/components/dialog/AddNotebookNoteDialog.vue'
import RenameDialog from '@/components/dialog/RenameDialog.vue'
import InsertImageDialog from '@/components/dialog/InsertImageDialog.vue'
import UploadImageDialog from '@/components/dialog/UploadImageDialog.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    TabSidebar,
    AddNotebookCatalogDialog,
    AddNotebookNoteDialog,
    RenameDialog,
    InsertImageDialog,
    UploadImageDialog
  },
  beforeRouteEnter (to, from, next) {
    const notebookId = to.params.notebookId
    const noteId = to.params.noteId
    next(async vm => {
      await vm.beforeRouteEnterOrUpdateHandler(notebookId, noteId, vm, next)
    })
  },
  async beforeRouteUpdate (to, from, next) {
    const notebookId = to.params.notebookId
    const noteId = to.params.noteId
    await this.beforeRouteEnterOrUpdateHandler(notebookId, noteId, this, next)
  },
  computed: {
    ...mapGetters({
      firstOpenedItem: 'workbench/opened/first'
    })
  },
  methods: {
    ...mapMutations({
      setCutData: 'contextmenu/SET_CUT_DATA',
      setSidebarActive: 'workbench/current/SET_SIDEBAR_ACTIVE',
      setSidebarVisible: 'workbench/SET_SIDEBAR_VISIBLE'
    }),
    ...mapActions({
      addOpened: 'workbench/opened/add',
      loadLastOpened: 'workbench/opened/loadLast'
    }),
    async beforeRouteEnterOrUpdateHandler (notebookId, noteId, vm, next) {
      vm.setSidebarActive(noteId ? 'outline' : 'catalog')
      vm.setSidebarVisible(true)

      vm.setCutData({})

      if (notebookId || noteId) {
        vm.addOpened({ notebookId, noteId })
        next()
        return
      }
      let lastOpened = vm.firstOpenedItem
      if (!lastOpened) {
        lastOpened = await vm.loadLastOpened()
      }

      if (lastOpened) {
        if (lastOpened.notebookId && lastOpened.noteId) {
          vm.$router.replace({
            name: 'workbenchNotebookNote',
            params: {
              noteId: lastOpened.noteId,
              notebookId: lastOpened.notebookId
            }
          })
          return
        }
        if (lastOpened.notebookId && !lastOpened.noteId) {
          vm.$router.replace({
            name: 'workbenchNotebook',
            params: {
              notebookId: lastOpened.notebookId
            }
          })
          return
        }
        if (!lastOpened.notebookId && lastOpened.noteId) {
          vm.$router.replace({
            name: 'workbenchNote',
            params: {
              noteId: lastOpened.noteId
            }
          })
          return
        }
      } else {
        this.$message({
          type: 'warning',
          message: '当前工作台尚未打开任何笔记本或笔记，可以新建或检索。',
          duration: 5000
        })
      }
      next()
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-layout__note {
  display: flex;
  flex-direction: row;
}
</style>
